"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MarkerEnd = function MarkerEnd(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.99",
    y: "2.76",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.56",
    y: "2.76",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.13",
    y: "2.76",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.7",
    y: "2.76",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.99",
    y: "5.33",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.56",
    y: "5.33",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.13",
    y: "5.33",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.7",
    y: "5.33",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.99",
    y: "7.9",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.56",
    y: "7.9",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.13",
    y: "7.9",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.7",
    y: "7.9",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "6.99",
    y: "10.47",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "9.56",
    y: "10.47",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.13",
    y: "10.47",
    width: "2.57",
    height: "2.57",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "14.7",
    y: "10.47",
    width: "2.57",
    height: "2.57",
    fill: "#1e1e1c"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,12.57A4.57,4.57,0,1,1,16.54,8,4.58,4.58,0,0,1,12,12.57ZM12,0A8,8,0,0,0,4,8c0,4.24,7.28,15.31,7.59,15.78a.5.5,0,0,0,.83,0C12.69,23.31,20,12.24,20,8A8,8,0,0,0,12,0Z"
  }));
};

MarkerEnd.propTypes = {
  className: _propTypes["default"].string
};
MarkerEnd.defaultProps = {
  className: 'fill-primary'
};
var _default = MarkerEnd;
exports["default"] = _default;